import { render } from "./Radio.vue?vue&type=template&id=550da4ec&scoped=true&ts=true"
import script from "./Radio.vue?vue&type=script&lang=ts"
export * from "./Radio.vue?vue&type=script&lang=ts"

import "./Radio.vue?vue&type=style&index=0&id=550da4ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550da4ec"]])

export default __exports__